export default "__VITE_ASSET__6c74576c__"